import classNames from 'classnames';
import PageHeading from 'es/app/components/typeography/PageHeading';
import { BootstrapStyles } from 'es/app/visuals/styles/BootstrapStyles';
import React from 'react';
import { useNavigate } from 'react-router-dom';

interface IUniversalSearchResultsProps {
    provider: string;
}

interface IUniversalSearchMatchProps<TMatch> {
    match: TMatch;
    heading: string;
    route?: string;
    onClick?: (match: TMatch) => void;
}

export const UniversalSearchResults = (props: React.PropsWithChildren<IUniversalSearchResultsProps>) => {
    return (
        <aside className={classNames('universal-search-provider-results', BootstrapStyles['mb-2'])}>
            <PageHeading>{props.provider}</PageHeading>
            {props.children}
        </aside>
    );
};

export const UniversalSearchMatch = <TMatch extends unknown>(
    props: React.PropsWithChildren<IUniversalSearchMatchProps<TMatch>>
) => {
    const navigate = useNavigate();

    const handleClick = () => {
        if (props.route) {
            navigate(props.route);
        } else if (props.onClick) {
            props.onClick(props.match);
        }
    };

    return (
        <div className="universal-search-match" onClick={handleClick}>
            <h6>{props.heading}</h6>
            {props.children}
        </div>
    );
};
